export default __webpack_public_path__ + "static/media/brand.c1052819.svg";